import { OCCUPATION_DATA } from '../../../../../constants/progressBanner'
import { CategoryData } from './types'

export const adaptOccupationData = (): CategoryData => {
    const adaptedData: CategoryData = {}

    Object.entries(OCCUPATION_DATA).forEach(([category, items]) => {
        adaptedData[category] = items.map(item => ({
            name: item.name,
            id: item.occupationId,
        }))
    })

    return adaptedData
}
